// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content_wrapper__3gMoG","album_wrapper":"Content_album_wrapper__p6VDC"};